import {http} from './config'

class ExtratoContaService {
  
    estornar(id){
        return http.post(`/v1/extrato-contas/estornar/${id}`)
    }

}

export default new ExtratoContaService